
function CompetitionMethodData(){
    let data = [
        {
            name:'局',
            unit:1<<0,
            mode:0
        },
        {
            name:'(锅/场)',
            unit:1<<1,
            mode:1
        },
        {
            name:'圈',
            unit:1<<2,
            mode:1
        },
    ]
    return data
}

function CompetitionMethodNum(unit){
    let data = [
        {
            name:'局',
            unit:1<<0,
            numS:[1 ,2, 3, 10 , 20 , 30 , 40]
        },
        {
            name:'(锅/场)',
            unit:1<<1,
            numS:[1 , 3,  5 , 7 ]
        },
        {
            name:'圈',
            unit:1<<2,
            numS:[1 ,2, 3, 4, 5]
        },
    ]
    return data.find(item => item.unit === unit)
}

export {
    CompetitionMethodData,
    CompetitionMethodNum
}


// WEBPACK FOOTER //
// ./src/utils/CompetitionMethod.js